import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { useCallback, useMemo } from 'react';
import { setDisplayParamsStacking } from 'reporting-data/report/configReportSetters';
import { getIsReportValidForReportStackingDropdown, getStackedValueFromConfigReportForDropdown } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const getStackedOptionsForUISelect = () => [{
  text: I18n.text('report-customization-components.customization-components.report-stacking-dropdown.config.options.none'),
  value: false
}, {
  text: I18n.text('report-customization-components.customization-components.report-stacking-dropdown.config.options.normal'),
  value: true
}, {
  text: I18n.text('report-customization-components.customization-components.report-stacking-dropdown.config.options.percent'),
  value: 'percent'
}];
const ConfigReportStackingDropdown = props => {
  const {
    report,
    onChange
  } = props;
  const dropdownOptions = getStackedOptionsForUISelect();
  const stackingValue = useMemo(() => {
    return getStackedValueFromConfigReportForDropdown(report);
  }, [report]);
  const onStackingChange = useCallback(({
    target: {
      value
    }
  }) => {
    onChange(setDisplayParamsStacking(report, value));
  }, [onChange, report]);
  if (!getIsReportValidForReportStackingDropdown({
    report
  })) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.report-stacking-dropdown.config.label"
    }),
    children: /*#__PURE__*/_jsx(Select, Object.assign({}, props, {
      options: dropdownOptions,
      value: stackingValue,
      onChange: onStackingChange
    }))
  });
};
export default ConfigReportStackingDropdown;